import BaseType from "./BaseType";

export default class Season extends BaseType {
  StartDate: string = "";
  EndDate: string = "";
  Active: boolean = false;
  Locked: boolean = false;
}
